import SvgIcon from './SvgIcon';
import { Box, Typography } from '@mui/material';

type StepperProps = {
  step: number;
  total: number;
  label: string;
  labelIcon?: string;
};

export const Stepper = ({ step, total, label, labelIcon }: StepperProps) => {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {labelIcon && (
          <SvgIcon src={labelIcon} style={{ fill: 'inherit', width: 24 }} />
        )}
        <Typography sx={{ mr: 1, ml: 2 }}>{label}</Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', py: 2 }}>
        <Box
          sx={{
            mr: 2,
            borderBottom: '2px solid #eee',
            flex: 1,
            height: 1,
          }}
        />
        <Typography sx={{ mr: 1 }}>
          {step}/{total}
        </Typography>
      </Box>
    </>
  );
};
